class AwardDetails {
  awardId = 0;
  
  awardName = '';

  priority = '';

  year = '';

  category = '';

  subCategory = '';

  constructor(awardDetails) {
    this.awardId = awardDetails.awardId;
    this.awardName = awardDetails.awardName;
    this.priority = awardDetails.priority;
    this.year = awardDetails.year;
    this.category = awardDetails.category;
    this.subCategory = awardDetails.subCategory;
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }

    return new AwardDetails(data);
  }

  static fromObjectList(list) {
    if (list == null) {
      return null;
    }

    return list.map((data) => AwardDetails.fromObject(data));
  }
}

export default AwardDetails;
